import Vue from "vue";
import Vuex from "vuex";

// Modules
import SimulatorPlans from "./simulator-plans";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        SimulatorPlans,
    },
    strict: process.env.DEV,
});
